import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TeammateService } from 'src/app/services/teammate.service';

@Component({
  selector: 'app-teammate-facility-roles',
  templateUrl: './teammate-facility-roles.component.html',
  styleUrls: ['./teammate-facility-roles.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class TeammateFacilityRolesComponent {
  private _teammateID: string = '';
  @Output() isLoadingRoles = new EventEmitter<boolean>();
  @Input()
  set teammateID(id: string) {
    // Only fetch if the ID is valid and has changed.
    if (id && id !== this._teammateID) {
      this._teammateID = id;
      this.showNoResults = false;
      this.getTeammateFacilityRoles(id);
    }
  }
  get teammateID(): string {
    return this._teammateID;
  }

  displayedColumnsFacilities: string[] = ['facilityName', 'facilityId', 'facilityCity', 'facilityState'];

  facilityRoles: any[] = [];
  facilityRolesTableData: MatTableDataSource<any>;
  showNoResults: boolean = false;
  
  // New properties for detailed view
  showDetailView: boolean = false;
  selectedTeammate: any = null;

  constructor(private teammateService: TeammateService) {
    this.facilityRolesTableData = new MatTableDataSource<any>();
  }

  getTeammateFacilityRoles(teammateID: string): void {
    this.isLoadingRoles.emit(true);
    this.teammateService.getTeammateFacilityRoles(teammateID).subscribe({
      next: (roles) => {
        if (roles && roles.result && roles.result.length > 0 && roles.result[0].roles && roles.result[0].roles.length > 0) {
          this.facilityRoles = roles.result[0].roles;
          this.facilityRolesTableData = new MatTableDataSource(this.facilityRoles);
          this.showNoResults = false;
        } else {
          this.facilityRoles = [];
          this.facilityRolesTableData = new MatTableDataSource();
          this.showNoResults = true;
        }
        this.isLoadingRoles.emit(false);
      },
      error: (error) => {
        console.error('Error getting facility roles:', error);
        this.facilityRoles = [];
        this.facilityRolesTableData = new MatTableDataSource();
        this.showNoResults = true;
        this.isLoadingRoles.emit(false);
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.facilityRolesTableData.filter = filterValue.trim().toLowerCase();
  }

  // New methods for detailed view
  onRowClick(teammate: any): void {
    this.selectedTeammate = teammate; 
    console.log(this.selectedTeammate);
    this.showDetailView = true;
  }

  onBackToTable(): void {
    this.showDetailView = false;
    this.selectedTeammate = null;
  }

  // Helper method to get all property keys for display
  getTeammateKeys(): string[] {
    if (!this.selectedTeammate) return [];
    return Object.keys(this.selectedTeammate);
  }

  // Helper method to format property names for display
  formatPropertyName(key: string): string {
    return key.replace(/([A-Z])/g, ' $1')
              .replace(/^./, str => str.toUpperCase())
              .trim();
  }

  get isTeammateProfileArray() {
    return Array.isArray(this.selectedTeammate.profiles);
  }
}
